var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback } from 'react';
// @ts-ignore
import { Container } from '../../react/base';
// eslint-disable-next-line lines-around-comment
// @ts-ignore
import { styleTypeToObject } from '../../styles';
export const DEFAULT_COLOR = navigator.product === 'ReactNative' ? 'white' : undefined;
export const DEFAULT_SIZE = navigator.product === 'ReactNative' ? 36 : 22;
/**
 * Implements an Icon component that takes a loaded SVG file as prop and renders it as an icon.
 *
 * @param {IProps} props - The props of the component.
 * @returns {ReactElement}
 */
export default function Icon(props) {
    var _a, _b, _c, _d, _e, _f;
    const { className, color, id, containerId, onClick, size, src: IconComponent, style, ariaHasPopup, ariaLabel, ariaDisabled, ariaExpanded, ariaControls, tabIndex, ariaPressed, ariaDescribedBy, role, onKeyPress, onKeyDown, width, height } = props, rest = __rest(props, ["className", "color", "id", "containerId", "onClick", "size", "src", "style", "ariaHasPopup", "ariaLabel", "ariaDisabled", "ariaExpanded", "ariaControls", "tabIndex", "ariaPressed", "ariaDescribedBy", "role", "onKeyPress", "onKeyDown", "width", "height"]);
    const _g = styleTypeToObject(style !== null && style !== void 0 ? style : {}), { color: styleColor, fontSize: styleSize } = _g, restStyle = __rest(_g, ["color", "fontSize"]);
    const calculatedColor = (_a = color !== null && color !== void 0 ? color : styleColor) !== null && _a !== void 0 ? _a : DEFAULT_COLOR;
    const calculatedSize = (_b = size !== null && size !== void 0 ? size : styleSize) !== null && _b !== void 0 ? _b : DEFAULT_SIZE;
    const currentSizeHeight = (_d = (_c = height !== null && height !== void 0 ? height : size) !== null && _c !== void 0 ? _c : styleSize) !== null && _d !== void 0 ? _d : DEFAULT_SIZE;
    const currentSizeWidth = (_f = (_e = width !== null && width !== void 0 ? width : size) !== null && _e !== void 0 ? _e : styleSize) !== null && _f !== void 0 ? _f : DEFAULT_SIZE;
    const onKeyPressHandler = useCallback(e => {
        if ((e.key === 'Enter' || e.key === ' ') && onClick) {
            e.preventDefault();
            onClick(e);
        }
        else if (onKeyPress) {
            onKeyPress(e);
        }
    }, [onClick, onKeyPress]);
    const jitsiIconClassName = calculatedColor ? 'jitsi-icon' : 'jitsi-icon jitsi-icon-default';
    return (React.createElement(Container, Object.assign({}, rest, { "aria-controls": ariaControls, "aria-describedby": ariaDescribedBy, "aria-disabled": ariaDisabled, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup, "aria-label": ariaLabel, "aria-pressed": ariaPressed, className: `${jitsiIconClassName} ${className || ''}`, id: containerId, onClick: onClick, onKeyDown: onKeyDown, onKeyPress: onKeyPressHandler, role: role, style: restStyle, tabIndex: tabIndex }),
        React.createElement(IconComponent, { fill: calculatedColor, height: currentSizeHeight, id: id, width: currentSizeWidth })));
}
Icon.defaultProps = {
    className: ''
};
